import { useTranslation } from 'react-i18next';

import { ModalsProvider } from '@speeki/global-ui-components';

import { Card } from '@components/molecules/Card/Card';
import {
    MobileModal,
    MobileModalProps,
} from '@components/organisms/MobileModal/MobileModal';

import { CheckStatusForm } from '@domains/auth/organisms/CheckStatusForm/CheckStatusForm';

interface MobileCaseStatusModalProps
    extends Pick<MobileModalProps, 'onClose' | 'open'> {}

export const MobileCaseStatusModal = ({
    onClose,
    open,
}: MobileCaseStatusModalProps) => {
    const { t } = useTranslation();
    return (
        <MobileModal footer onClose={onClose} open={open} topPadding={54}>
            <MobileModal.Container>
                <Card testId="IUjZlxX">
                    <Card.TitleTertiary fontWeight="normal">
                        {t('CHECK_CASE_STATUS')}
                    </Card.TitleTertiary>
                    <Card.Description>{t('HOME_GUEST_INFO')}</Card.Description>
                    <CheckStatusForm
                        onSuccess={() =>
                            ModalsProvider.close('MobileCaseStatusModal')
                        }
                    />
                </Card>
            </MobileModal.Container>
        </MobileModal>
    );
};
